function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import { PropTypes, func, oneOf, number, node } from "prop-types";
import PactometroCheck from "./checks";
import PactometroBarrasSimple from "./barrasSimple";
import "./index.scss";
import { SCContainerPactometroSimple } from "./style";

const PactometroCheckSimple = ({
  seatData,
  totalSeat,
  onChange: _onChange,
  checksCols,
  cols,
  legend
}) => {
  const _useState = useState([]),
        _useState2 = _slicedToArray(_useState, 2),
        selectedsId = _useState2[0],
        setSelectedsId = _useState2[1];

  const filterData = seatData.filter(current => current.seats >= 1);

  const _filterData$reduce = filterData.reduce((tot, current) => {
    tot.totalVotes += current.votes;
    tot.totalSeat += current.seats;
    return tot;
  }, {
    totalVotes: 0,
    totalSeat: 0
  }),
        totalVotes = _filterData$reduce.totalVotes;

  return React.createElement(SCContainerPactometroSimple, {
    className: "containerPactometro",
    cols: cols
  }, React.createElement("div", {
    className: "content-pactos-barras content-pactos-barrasSimple"
  }, React.createElement(PactometroBarrasSimple, {
    data: filterData,
    selecteds: selectedsId,
    totalSeat: totalSeat,
    totalVotes: totalVotes
  })), React.createElement("div", {
    className: "content-pactos content-pactosSimple"
  }, legend && React.createElement("p", {
    className: "legend content-pactos_legend"
  }, legend), React.createElement("div", {
    className: "pactosScrollContent"
  }, React.createElement("div", {
    className: "pactosScroll"
  }, React.createElement(PactometroCheck, {
    data: filterData,
    selecteds: selectedsId,
    onChange: val => {
      setSelectedsId(val);
      _onChange && _onChange(val);
    }
  })))));
};

PactometroCheckSimple.defaultProps = {
  cols: 1
};
PactometroCheckSimple.propTypes = {
  seatData: PropTypes.arrayOf(PropTypes.shape({
    partyAcronym: PropTypes.string.isRequired,
    seats: PropTypes.number.isRequired,
    votesPercent: PropTypes.number.isRequired,
    votes: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired
  })).isRequired,
  onChange: func,
  checksCols: number,
  cols: oneOf([1, 2]),
  legend: node
};
export default PactometroCheckSimple;